module.exports = __webpack_public_path__ + "img/Group-60.f03c48b3.jpg";